export default {
  BlurFocus: {
    mounted() {
      this.isDestroyed = false;
      this.initialize();
    },

    updated() {
      this.initialize();
    },

    destroyed() {
      this.isDestroyed = true;
      this.cleanup();
    },

    initialize() {
      this.toggleId = this.el.dataset.toggleId;
      this.eventTarget = this.el.dataset.eventTarget;
      this.onBlurEvent = this.el.dataset.onBlurEvent;
      this.onFocusEvent = this.el.dataset.onFocusEvent;
      this.inputName = this.el.dataset.inputName;

      // Use a small delay to ensure the toggle button is rendered
      const rootElement = this.el;
      setTimeout(() => {
        if (this.isDestroyed || !rootElement.isConnected) return;
        this.setupListeners();
      }, 100);
    },

    setupListeners() {
      if (this.toggleId) {
        const toggleButton = document.getElementById(this.toggleId);
        if (toggleButton) {
          // Set up focus listener
          if (this.onFocusEvent && !this.onFocusCallback) {
            this.onFocusCallback = this.onFocus.bind(this);
            toggleButton.addEventListener('focus', this.onFocusCallback);
          }

          // Set up blur listener
          if (this.onBlurEvent && !this.onBlurCallback) {
            this.onBlurCallback = this.onBlur.bind(this);
            toggleButton.addEventListener('blur', this.onBlurCallback);
          }

          // Track if we're clicking on the toggle button to prevent blur->focus chain
          if (!this.onToggleClickCallback) {
            this.onToggleClickCallback = this.onToggleClick.bind(this);
            toggleButton.addEventListener('mousedown', this.onToggleClickCallback);
          }
        }
      }

      // Set up click-away listener to blur the toggle button
      if (this.toggleId && !this.onClickAwayCallback) {
        this.onClickAwayCallback = this.onClickAway.bind(this);
        document.addEventListener('click', this.onClickAwayCallback, true);
      }
    },

    cleanup() {
      if (this.toggleId) {
        const toggleButton = document.getElementById(this.toggleId);
        if (toggleButton) {
          if (this.onFocusCallback) {
            toggleButton.removeEventListener('focus', this.onFocusCallback);
            this.onFocusCallback = null;
          }
          if (this.onBlurCallback) {
            toggleButton.removeEventListener('blur', this.onBlurCallback);
            this.onBlurCallback = null;
          }
          if (this.onToggleClickCallback) {
            toggleButton.removeEventListener('mousedown', this.onToggleClickCallback);
            this.onToggleClickCallback = null;
          }
        }
      }

      if (this.onClickAwayCallback) {
        document.removeEventListener('click', this.onClickAwayCallback, true);
        this.onClickAwayCallback = null;
      }
    },

    onFocus() {
      this.dispatchFocusEvent();
    },

    onToggleClick() {
      // Mark that we're clicking on the toggle button
      // This prevents blur from firing when focus moves to the toggle button
      this.isClickingToggle = true;
      // Reset the flag after a short delay
      setTimeout(() => {
        if (this.isDestroyed) return;
        this.isClickingToggle = false;
      }, 100);
    },

    onBlur() {
      // Don't dispatch blur if we're clicking on the toggle button itself
      // (which would cause a blur->focus chain)
      if (!this.isClickingToggle) {
        this.dispatchBlurEvent();
      }
    },

    onClickAway(event) {
      // Check if click is inside the component
      if (this.el.contains(event.target)) {
        return;
      }

      // Find and blur the toggle button
      if (this.toggleId) {
        const toggleButton = document.getElementById(this.toggleId);
        if (toggleButton && document.activeElement === toggleButton) {
          toggleButton.blur();
        }
      }
    },

    dispatchFocusEvent() {
      if (this.onFocusEvent) {
        const rootElement = this.el;
        const eventTarget = this.eventTarget;
        const inputName = this.inputName;
        const onFocusEvent = this.onFocusEvent;

        setTimeout(() => {
          if (this.isDestroyed || !rootElement.isConnected) return;

          if (eventTarget) {
            this.pushEventTo(eventTarget, onFocusEvent, { name: inputName });
          } else {
            this.pushEventTo(rootElement, onFocusEvent, { name: inputName });
          }
        }, 50);
      }
    },

    dispatchBlurEvent() {
      if (this.onBlurEvent) {
        const rootElement = this.el;
        const eventTarget = this.eventTarget;
        const inputName = this.inputName;
        const onBlurEvent = this.onBlurEvent;

        setTimeout(() => {
          if (this.isDestroyed || !rootElement.isConnected) return;

          if (eventTarget) {
            this.pushEventTo(eventTarget, onBlurEvent, { name: inputName });
          } else {
            this.pushEventTo(rootElement, onBlurEvent, { name: inputName });
          }
        }, 50);
      }
    },
  },
};
